// extracted by mini-css-extract-plugin
export default {"wrapper":"sortSelectBox_wrapper__QDMjq","popup":"sortSelectBox_popup__MuHIm","displayIcon":"sortSelectBox_displayIcon__OjXGu"};